<div class="relative flex w-full justify-center">
  <canvas #doughnutChart class="h-full w-full"></canvas>
</div>
